import { render, staticRenderFns } from "./CConfirm.vue?vue&type=template&id=3d768d6b&"
import script from "./CConfirm.vue?vue&type=script&lang=ts&"
export * from "./CConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports